module.exports = __webpack_public_path__ + "img/empty-folder.1ba4efa2.svg";